"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensingHelper = void 0;
var constants_1 = require("../../../api/constants");
var uniq_1 = __importDefault(require("lodash/uniq"));
var LicensingHelper = /** @class */ (function () {
    function LicensingHelper(licenses) {
        this.licenses = licenses;
    }
    LicensingHelper.prototype.isProductLicensed = function (productId) {
        return this.licenses.filter(function (license) { return license.hasProduct(productId); }).length > 0;
    };
    LicensingHelper.prototype.isCurriculumLicensed = function (CurriculumId) {
        return this.licenses.filter(function (license) { return license.typeOfCurriculumIs(CurriculumId); }).length > 0;
    };
    LicensingHelper.prototype.isAffirmLicensed = function () {
        return this.isProductLicensed(constants_1.ProductId.Affirm);
    };
    LicensingHelper.prototype.isEquipLicensed = function () {
        return this.isProductLicensed(constants_1.ProductId.Equip);
    };
    LicensingHelper.prototype.isInsyncLicensed = function () {
        return this.isProductLicensed(constants_1.ProductId.InSync);
    };
    LicensingHelper.prototype.isInklingLicensed = function () {
        return this.isProductLicensed(constants_1.ProductId.Inkling);
    };
    LicensingHelper.prototype.isEurekaMathLicensed = function () {
        return this.isCurriculumLicensed(constants_1.CurriculumId.EurekaMath);
    };
    LicensingHelper.prototype.isDigitalLicensed = function () {
        return this.isProductLicensed(constants_1.CurriculumId.Digital);
    };
    LicensingHelper.prototype.isWitAndWisdomLicensed = function () {
        return this.isCurriculumLicensed(constants_1.CurriculumId.WitAndWisdom);
    };
    LicensingHelper.prototype.getProductCurriculums = function (productId) {
        return this.licenses
            .filter(function (license) { return license.hasProduct(productId); })
            .map(function (_a) {
            var curriculum = _a.curriculum;
            return curriculum.id;
        });
    };
    LicensingHelper.prototype.getLicenseIdsOfCurriculum = function (curriculum) {
        return this.licenses.filter(function (license) { return license.hasCurriculum(curriculum); }).map(function (_a) {
            var id = _a.id;
            return id;
        });
    };
    LicensingHelper.prototype.getAppProductIds = function () {
        return (0, uniq_1.default)(this.licenses
            .map(function (_a) {
            var product = _a.product;
            return product === null || product === void 0 ? void 0 : product.id;
        })
            .filter(function (id) { return id === constants_1.ProductId.Affirm || constants_1.ProductId.Equip; }));
    };
    LicensingHelper.prototype.getAppCurriculumIds = function () {
        return (0, uniq_1.default)(this.licenses.map(function (_a) {
            var curriculum = _a.curriculum;
            return curriculum === null || curriculum === void 0 ? void 0 : curriculum.id;
        }));
    };
    return LicensingHelper;
}());
exports.LicensingHelper = LicensingHelper;
